import sendGaComponentEvent from '@gc-npm/utils.metrics.send-ga-component-event';

export const sendTaggingInfo = (taggingInfo, eventType) => {
  const finalTaggingInfo = {
    ...taggingInfo,
    eventType,
  };
  try {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    const isFrontApp = typeof window !== 'undefined';
    const isMetricsDevEnable =
      isFrontApp && window.location.search.indexOf('metrics') > -1;
    if ((isFrontApp && currentEnv !== 'dev') || isMetricsDevEnable) {
      sendGaComponentEvent(finalTaggingInfo);
    }
  } catch (err) {
    throw err;
  }
};